export default "__VITE_ASSET__B6tS5_34__"